<script>
export default {
    name: "InvoiceDetails",

    props: {

        showModal: Boolean,
        invoice: Object,
    },

    computed: {

        totalInsuranceAmt() {

            if(!this.invoice.invoiceItems.length) return 0;

            const filteredItems = this.invoice.invoiceItems.filter(invItem => invItem.insuranceAmountPaid);

            if(!filteredItems.length) return 0;

            const invItems = filteredItems.map(item => parseFloat(item.insuranceAmountPaid));

            return invItems.reduce((cost, accTotal) => cost + accTotal);
        },
    },

    methods: {

        printInvoiceDetails() {
            let url = `/reports/accounts-finance/invoices-per-visit-details/print`;
                url += `?patientID=${this.invoice.patientID}`;
                url += `&visitNo=${this.invoice.visitNo}`;

            window.open(url,
             '_blank', 
             `ReportPrint`, 
             "menubar=yes,location=yes,resizable=yes,scrollbars=yes,status=yes");
        },
    },
}
</script>
<template>
<tail-modal :show="showModal" dimension="w-11/12 md:w-2/3">
  <template v-slot:title>
    <h5 class="font-bold text-base">Invoice Details </h5>
  </template>
  <template v-slot:modal-body>
    <div class="flex flex-col -m-3">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap p-1">
            <div class="flex-1">
                <h5 class="font-bold">Patient: 
               <span class="text-blue-800">{{ invoice.patient }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">OP File No: 
               <span class="text-blue-800">{{ invoice.opfileNo || `-` }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">IP File No: 
               <span class="text-blue-800">{{ invoice.ipfileNo || `-` }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Visit No: 
               <span class="text-blue-800">{{ invoice.visitNo }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Invoice NO: 
               <span class="text-blue-800">{{ invoice.invoice_No }}</span></h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Organization: 
               <span class="text-blue-800">{{ invoice.organization }}</span></h5>
            </div>
        </div>
        <div class="w-full overflow-auto">
            <table class="table table-hover">
                <thead class="bg-blue-500 text-sm text-white">
                    <tr>
                        <th class="p-tiny">#</th>
                        <th class="p-tiny">Bill No</th>
                        <th class="p-tiny">Item</th>
                        <th class="p-tiny">Description</th>
                        <th class="p-tiny">User</th>
                        <th class="p-tiny">Qty</th>
                        <th class="p-tiny">Cost</th>
                        <th class="p-tiny">Insurance Amt</th>
                    </tr>
                </thead>
                <tfoot class="text-sm">
                      <tr>
                          <th colspan="6" class="p-tiny"></th>
                          <th class="p-tiny">Total</th>
                          <th class="p-tiny">{{ totalInsuranceAmt | numberFormat }}</th>
                      </tr>
                </tfoot>
                <tbody class="text-sm">
                    <tr v-for="(invoiceItem, idx) in invoice.invoiceItems" :key="idx">
                        <td class="p-tiny">{{ invoiceItem.invoiceDetailID }}</td>
                        <td class="p-tiny">{{ invoiceItem.billNo }}</td>
                        <td class="p-tiny">{{ invoiceItem.item }}</td>
                        <td class="p-tiny">{{ invoiceItem.description }}</td>
                        <td class="p-tiny">{{ invoiceItem.userName }}</td>
                        <td class="p-tiny">{{ invoiceItem.qty }}</td>
                        <td class="p-tiny">{{ invoiceItem.charge | numberFormat }}</td>
                        <td class="p-tiny">{{ invoiceItem.insuranceAmountPaid | numberFormat }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
  </template>
  <template v-slot:modal-footer>
    <button class="btn-danger btn-sm text-xs rounded mr-6" 
        @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Cancel</button>
    <button class="btn-primary btn-sm text-xs rounded" 
        @click.prevent="printInvoiceDetails">
            <i class="fa fa-print"></i> Print</button>
  </template>
</tail-modal>
</template>